var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mac-banner-container",style:({ marginTop: _vm.topDistance })},[_c('div',{staticClass:"mac-banner"},[_c('p',{staticClass:"mac-title"},[_vm._v(_vm._s(_vm.title))]),_c('p',{staticClass:"mac-desc"},[_vm._v(_vm._s(_vm.description))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }